export const USER_PROFILE_STATIC_BASIC_INFO = "USER_PROFILE_STATIC_BASIC_INFO";
export const USER_PROFILE_DYNAMIC_BASIC_INFO =
  "USER_PROFILE_DYNAMIC_BASIC_INFO";
export const USER_PROFILE_SESSION_INFO = "USER_PROFILE_SESSION_INFO";
export const USER_PROFILE_CRASH_INFO = "USER_PROFILE_CRASH_INFO";
export const USER_PROFILE_SESSIONS_LIST = "USER_PROFILE_SESSIONS_LIST";
export const USER_PROFILE_SESSION_TIMELINE = "USER_PROFILE_SESSION_TIMELINE";
